module.exports = __webpack_public_path__ + "img/slide2.65364d09.png";